import { useCallback, useEffect, useMemo, useState } from "react"

import { Flex, Skeleton } from "antd"
import { useSelector } from "react-redux"

import { PROGRAM_META } from "../../constants/receipt-status-mapping"
import { selectPrograms } from "../../redux/receipt.slice"
import { ReceiptProgramCard } from "./ReceiptProgramCard"

import styles from "./styles.module.less"

const ProgramSelector = ({ selectedProgram, getPrograms, onSelect }) => {
  const programs = useSelector(selectPrograms)
  const [loading, setLoading] = useState(false)

  const handleGetReceiptState = useCallback(async () => {
    try {
      setLoading(true)
      await getPrograms()
    } finally {
      setLoading(false)
    }
  }, [getPrograms])

  const cards = useMemo(
    () =>
      programs.map((p) => {
        const id = p.program.toLowerCase()
        const meta = PROGRAM_META?.[id]

        return {
          id,
          name: meta?.name,
          iconType: meta.iconType,
          value: p?.lookup_count,
          status: p?.status
        }
      }),
    [programs]
  )

  useEffect(() => {
    void handleGetReceiptState()
  }, [handleGetReceiptState])

  return (
    <Flex gap={16} className={styles.selector}>
      {loading
        ? Array.from({ length: 3 }, (_, i) => (
            <Flex key={i} vertical justify="space-between" className={styles.card}>
              <Skeleton.Node active size="small" className={styles.skeletonName} />
              <Flex justify="space-between" align="flex-end">
                <Skeleton.Node active size="large" className={styles.skeletonValue} />
                <Skeleton.Node active size="small" className={styles.skeletonChip} />
              </Flex>
            </Flex>
          ))
        : cards.map((c) => (
            <ReceiptProgramCard
              key={c.id}
              {...c}
              isActive={selectedProgram === c.id}
              onClick={onSelect}
            />
          ))}
    </Flex>
  )
}

export default ProgramSelector
